import { GzAntimalwareOnDemandScanTaskTargetFormWebComponent } from './component/GzAntimalwareOnDemandScanTaskTargetFormWebComponent';

export { GzAntimalwareOnDemandScanTaskTargetFormWebComponent };
